"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfigDir = defaultConfigDir;
exports.getOrCreateInstallId = getOrCreateInstallId;
exports.newSessionId = newSessionId;
const crypto_1 = require("crypto");
const os = __importStar(require("os"));
const path = __importStar(require("path"));
const fs = __importStar(require("fs"));
/**
 * User-global directory where the anonymous install id is persisted. User-global
 * (not per-repo) on purpose: retention ("do they return") and cross-repo dedupe
 * both need ONE stable id per user. Honours `LOOM_CONFIG_DIR`, then the platform
 * convention (%APPDATA% on Windows, `$XDG_CONFIG_HOME` or `~/.config` elsewhere).
 */
function defaultConfigDir(env = process.env) {
    if (env.LOOM_CONFIG_DIR && env.LOOM_CONFIG_DIR.trim()) {
        return env.LOOM_CONFIG_DIR;
    }
    if (process.platform === 'win32' && env.APPDATA && env.APPDATA.trim()) {
        return path.join(env.APPDATA, 'loom');
    }
    const xdg = env.XDG_CONFIG_HOME;
    const base = xdg && xdg.trim() ? xdg : path.join(os.homedir(), '.config');
    return path.join(base, 'loom');
}
/**
 * Read the persisted anonymous install id, creating it on first call. The id is a
 * random UUID with NO link to any project, path, machine name, or user identity.
 *
 * Only ever call this AFTER consent — never mint an id for a user who has not
 * opted in. If the store cannot be written (read-only FS, etc.) an ephemeral id
 * is returned so a session still coheres, without crashing.
 */
function getOrCreateInstallId(configDir = defaultConfigDir()) {
    const file = path.join(configDir, 'telemetry.json');
    try {
        const parsed = JSON.parse(fs.readFileSync(file, 'utf8'));
        if (parsed && typeof parsed.installId === 'string' && parsed.installId) {
            return parsed.installId;
        }
    }
    catch {
        /* not created yet — fall through and create it */
    }
    const installId = (0, crypto_1.randomUUID)();
    try {
        fs.mkdirSync(configDir, { recursive: true });
        fs.writeFileSync(file, JSON.stringify({ installId }, null, 2), 'utf8');
    }
    catch {
        /* best-effort persistence; the ephemeral id below still works this run */
    }
    return installId;
}
/** A fresh per-process session id — the retention/return anchor within a run. */
function newSessionId() {
    return (0, crypto_1.randomUUID)();
}
